<template>
  <div class="join-survey">
    <v-row>
      <v-col>
        <SurveyInfo
          v-if="currentState === 'start'"
          title="Soft skills survey"
          description="The survey will take no more than 5 minutes, honest answers will help us
            choose projects in which you will feel best. At the end you will receive our
            recommendation."
          action-name="Start survey"
          image
          @click="startSurvey" />

        <SurveyForm
          v-else-if="currentState === 'survey'"
          :survey-step="survey[currentStep]"
          :progress="surveyProgress"
          :processing="isSubmitProcessing"
          :last="isLastStep"
          @submit="submitStep"
        />

        <SurveyInfo
          v-else-if="currentState === 'end'"
          title="Thank you!"
          description="Thank you for going through the survey.
            Soon you will receive a recommendation from us and the first
            project proposals selected for you."
          action-name=""
          @click="backToProfile" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import SurveyForm from '@/components/Survey/SurveyForm.vue';
import SurveyInfo from '@/components/Survey/SurveyInfo.vue';

export default {
  components: {
    SurveyForm,
    SurveyInfo,
  },

  props: {
    token: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      currentState: 'start',
      currentStep: 0,
      isSubmitProcessing: false,
    };
  },

  computed: {
    ...mapState('survey', [
      'survey',
    ]),

    numberOfSteps() {
      return Object.keys(this.survey).length;
    },

    isLastStep() {
      return this.currentStep === this.numberOfSteps - 1;
    },

    surveyProgress() {
      return this.currentStep ? (this.currentStep / this.numberOfSteps) * 100 : 0;
    },
  },

  created() {
    this.fetchSurvey();
  },

  methods: {
    ...mapActions('survey', [
      'fetchSurvey',
      'submitSurvey',
      'addAnswers',
    ]),

    startSurvey() {
      this.currentState = 'survey';
    },

    submitStep(answers) {
      this.addAnswers(answers);

      if (this.isLastStep) {
        this.isSubmitProcessing = true;

        this.submitSurvey(this.token)
          .then(() => {
            this.currentState = 'end';
          })
          .finally(() => {
            this.isSubmitProcessing = false;
          });
      } else {
        this.currentStep += 1;
      }
      setTimeout(() => {
        this.$vuetify.goTo(0);
      }, 0);
    },

    backToProfile() {},
  },
};
</script>

<style lang="scss" scoped>
.join-survey {
  min-height: calc(100vh - 90px);
  display: flex;
  align-items: center;
}
</style>
